export default __webpack_public_path__ + "static/media/screen1.14635559.jpg";